import {Component} from '@angular/core';
import {CommunitiesService} from "../_services/communities.service";
import {ThemeService} from "../_services/theme.service";
import {User} from "../_types/user";
import {AuthService} from "../_services/auth.service";

@Component({
    selector: 'app-authview',
    templateUrl: './authview.component.html',
    styleUrls: ['./authview.component.scss'],
})

export class AuthviewComponent {
    backgroundImage: string = '';
    user: User | null = null;

    constructor(private communitiesService: CommunitiesService,
                private themeService: ThemeService,
                private authService: AuthService) {
        this.user = this.authService.getUser();

        this.communitiesService.backgroundImageChange.subscribe((value: string): void => {
            this.backgroundImage = value;
        });

        this.themeService.updateCurrentBrightnessTheme();
    }
}
